import React, { useState } from "react";

const Products = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showAddProduct, setShowAddProduct] = useState(false);

  const products = [
    {
      id: 1,
      image: "",
      name: "Product A",
      category: "Food",
      price: 120,
      stock: 50,
      status: "Active",
    },
    {
      id: 2,
      image: "",
      name: "Product B",
      category: "Beverage",
      price: 80,
      stock: 12,
      status: "Active",
    },
  ];

  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="products-page">

      {/* Products Header */}
      <div className="products-toolbar">

        <input
          type="text"
          className="products-search-input"
          placeholder="Search Products"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <button
          className="add-product-button"
          onClick={() => setShowAddProduct(true)}
        >
          + Add Product
        </button>

      </div>


      {/* Products Table */}
      <div className="products-table-container">

        <table className="products-table">

          <thead>
            <tr>
              <th>Product Image</th>
              <th>Product Name</th>
              <th>Category</th>
              <th>Price</th>
              <th>Stock</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>

            {filteredProducts.map((product) => (
              <tr key={product.id}>

                <td>
                  <div className="product-image-placeholder">
                    Image
                  </div>
                </td>

                <td>{product.name}</td>

                <td>{product.category}</td>

                <td>?{product.price}</td>

                <td>{product.stock}</td>

                <td>
                  <span className="product-status active">
                    {product.status}
                  </span>
                </td>

              </tr>
            ))}

          </tbody>

        </table>

      </div>


      {/* =========================
          ADD PRODUCT MODAL
      ========================== */}

      {showAddProduct && (

        <div className="product-modal-overlay">

          <div className="product-modal">

            <div className="product-modal-header">

              <h2>Add Product</h2>

              <button
                className="close-modal-button"
                onClick={() => setShowAddProduct(false)}
              >
                �
              </button>

            </div>


            <div className="product-form">

              <label>
                Product Name
              </label>

              <input
                type="text"
                placeholder="Enter product name"
              />


              <label>
                Category
              </label>

              <input
                type="text"
                placeholder="Enter category"
              />


              <label>
                Price
              </label>

              <input
                type="number"
                placeholder="Enter price"
              />


              <label>
                Stock
              </label>

              <input
                type="number"
                placeholder="Enter stock quantity"
              />


              <label>
                Product Image
              </label>

              <input
                type="file"
                accept="image/*"
              />


              <div className="product-form-buttons">

                <button
                  className="cancel-product-button"
                  onClick={() => setShowAddProduct(false)}
                >
                  Cancel
                </button>

                <button
                  className="save-product-button"
                >
                  Save Product
                </button>

              </div>

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

export default Products;